import { AlertTriangle } from "lucide-react";
import { Link } from "react-router";
import { useT } from "../../i18n";

export const TWO_ROOM_PANORAMA_MIGRATION_URL =
	"/builder/tvarum?entryWall=long&glazingStyle=panorama&saunaPosition=left&hasRelaxRoom=true&view=design";

export function DeprecatedBarrelBanner() {
	const t = useT();

	return (
		<section className="deprecated-barrel-banner" aria-labelledby="barrel-deprecated-title">
			<div className="deprecated-barrel-banner__icon" aria-hidden="true">
				<AlertTriangle size={20} strokeWidth={2.2} />
			</div>
			<div className="deprecated-barrel-banner__content">
				<h2 id="barrel-deprecated-title">{t.builder_barrel_deprecated_title}</h2>
				<p>{t.builder_barrel_deprecated_body}</p>
			</div>
			<Link
				className="deprecated-barrel-banner__cta"
				to={TWO_ROOM_PANORAMA_MIGRATION_URL}
			>
				{t.builder_barrel_deprecated_cta}
			</Link>
		</section>
	);
}
